import React from 'react';
import { Chip } from '@mui/material';

const ProcedureVersionBadge = ({ version }) => {
  if (!version) return null;

  return (
    <Chip 
      label={`Template v${version}`}
      size="small"
      variant="outlined"
      color="primary"
      sx={{ mb: 1 }}
    />
  );
};

export default ProcedureVersionBadge;
